import { Component } from '@angular/core';
import { TemplateEmailListComponent } from '@harlowe/core';

@Component({
  selector: 'app-email-templates-manager',
  standalone: true,
  imports: [TemplateEmailListComponent],
  templateUrl: './email-templates-manager.component.html',
  styleUrl: './email-templates-manager.component.scss'
})
export class EmailTemplatesManagerComponent {

}
